var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"discount-confirmations-modal-footer"},[_c('IdfButton',{attrs:{"kind":"secondary"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.$t('ctx.discount.cancel')))]),_c('IdfButton',{attrs:{"disabled":_vm.canValidate},on:{"click":_vm.validate}},[_vm._v(_vm._s(_vm.$t('ctx.discount.validate')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }